import {FormElementType} from "../../enums/formElementType";
import FormElement from "../../../formability/form_builder/models/formElements/formElement";

export const FormElementTypesForMappings = [
  FormElementType.textField,
  FormElementType.textArea,
  FormElementType.dateTimePicker,
  FormElementType.dropdown,
  FormElementType.checkboxGroup,
  FormElementType.radioButtonGroup,
  FormElementType.signature,
  FormElementType.uploadFiles,
  FormElementType.imageUpload,
];

export function commonFilterMappingFormElements(formElement) {
  return (
    !formElement.is_repeatable &&
    formElement.isTypeOneOf(FormElementTypesForMappings) &&
    isPermittedChild(formElement)
  )
}

export function isPermittedChild(formElement) {
  const unpermitted = [FormElementType.imageUpload];
  return formElement.parent && !unpermitted.includes(formElement.parent.element_type)
}